import React from 'react'
import { Container, Tab } from 'semantic-ui-react';
import { ContentList } from '../components';
import {products} from '../assets/images';

const panes = [
  {
    menuItem: 'Sari',
    render: () => sariContent(),
  },
  {
    menuItem: 'Kurti',
    render: () => emptyContent(),
  },
  {
    menuItem: 'Jewellery',
    render: () => emptyContent(),
  },
]


const ProductSection = () => (
  <div style={styles.root}>
    <Container textAlign='center'>
      <h1 style={styles.titleText}>Our Products</h1>
      <br/><br/>
    </Container>
    <center>
    <Tab menu={{ size: 'huge', secondary: true }} panes={panes} />
    </center>
  </div>
)

const sariContent = () => (
  <ContentList contents={products}/>
)

const emptyContent = () => (
  <div style={{height: '200px', margin: '100px'}}>
    <center>
      <h3>No content Available</h3>
    </center>
  </div>
)


const styles = {
  root: {
    paddingTop: '100px',
    paddingBottom: '100px',
    paddingLeft: '20px',
    paddingRight: '20px',
  },
  
  titleText: {
    fontSize: '70px',
    fontStyle: 'italic',
  }
}

export {ProductSection};